module.exports = __webpack_public_path__ + "img/finviz.ea9c1f34.png";